module.exports = __webpack_public_path__ + "static/register_home-4de88c57bd270bdbda89a668323ee997.png";